type Props = {
  title: string
  description: string
  className?: string
  'data-testid'?: string
}

const PageDetails = ({
  title,
  description,
  className,
  'data-testid': dataTestId,
}: Props) => (
  <header className={className}>
    <h3
      data-testid={dataTestId}
      className="text-4xl font-medium text-base-700 font-relais pb-3"
    >
      {title}
    </h3>
    <p className="text-base text-base-700 font-normal">{description}</p>
  </header>
)

export default PageDetails
